import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle-orange2--sprite",
  "use": "plus-circle-orange2--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-circle-orange2--sprite\">\n<path d=\"M12 0.333344C5.56004 0.333344 0.333374 5.56001 0.333374 12C0.333374 18.44 5.56004 23.6667 12 23.6667C18.44 23.6667 23.6667 18.44 23.6667 12C23.6667 5.56001 18.44 0.333344 12 0.333344ZM17.8334 13.1667H13.1667V17.8333H10.8334V13.1667H6.16671V10.8333H10.8334V6.16668H13.1667V10.8333H17.8334V13.1667Z\" fill=\"var(--Brand-Primary)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol